import PasswordResetComponent from "../../components/Auth/passwordReset";

export default function PasswordResetScreen(){
return <PasswordResetComponent />
}